import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../services/app.service';

@Pipe({
  name: 'elsoGridHospitalizationFilter',
  pure: false
})
export class ELSOHospitalizationFilterPipe implements PipeTransform {
  constructor(public appService: AppService) { }

  grandChildProperties = ['TimeOn', 'RunNo', 'submittedDate'];

  transform(items: any[], filter: string, sortByProperty?: string, sortByOrder?: string): any {


    if (!items) {
      return items;
    }

    var sortedFilteredArray = items;
    var sortByOrderDefault = 'asc';
    if (sortByOrder) {
      sortByOrderDefault = sortByOrder
    }

    if (sortByProperty) {
      if (this.grandChildProperties.includes(sortByProperty)) {
        console.log('bingo');
        sortedFilteredArray = this.sortPatientsByRunProperty(sortedFilteredArray, sortByProperty, sortByOrderDefault);

        //const multiplier = sortByOrderDefault === "desc" ? -1 : 1;
        //if (sortByProperty == "TimeOn") {
        //  sortedFilteredArray.sort((a, b) => (this.sortByTimeOn(a) - this.sortByTimeOn(b)) * multiplier);
        //} else if (sortByProperty == "RunNo") {
        //  sortedFilteredArray.sort((a, b) => (this.getLowestRunNo(a) - this.getLowestRunNo(b)));
        //}
      } else {
        sortedFilteredArray = this.appService.lodashOrderBy(sortedFilteredArray, [sortByProperty], [sortByOrderDefault]);
      }
    }

    if (filter) {
      if (filter.trim() != "") {
        sortedFilteredArray = this.filterByValue(sortedFilteredArray, filter);
      }
    }
    return sortedFilteredArray;
  }


  getMinRunValue(patient, property) {
    console.log('www');

    return Math.min(
      ...patient.Hospitalizations.flatMap(h =>
        h.Runs.map(r => {
          const value = r[property];

          if (property === "TimeOn" || property === "submittedDate") {
            return value ? new Date(value).getTime() : Infinity
          }

          return value; // e.g. RunNo

        })
      )
    );
  }

  sortPatientsByRunProperty(patients, property, direction = "asc") {
    return patients.sort((a, b) => {
      const valueA = this.getMinRunValue(a, property);
      const valueB = this.getMinRunValue(b, property);

      return direction === "desc"
        ? valueB - valueA
        : valueA - valueB;
    });
  }


  filterByValue(array, string) {
    return array.filter(o => {
      return Object.keys(o).some(k => {
        if (o[k] != null)
          return o[k].toString().toLowerCase().includes(string.toLowerCase())
      })
    });
  }

  //getLowestRunNo(patient) {
  //  return Math.min(
  //    ...patient.Hospitalizations.flatMap(h =>
  //      h.Runs.map(r => r.RunNo)
  //    )
  //  );
  //}

  //sortByTimeOn(patient) {
  //  return Math.min(
  //    ...patient.Hospitalizations.flatMap(h =>
  //      h.Runs.map(r => new Date(r.TimeOn).getTime())
  //    )
  //  );
  //}



  //filterByChildProperty(array, property) {
  //  const sortedByNewestChild = array.sort((a, b) => {
  //    // 1. Extract timestamps of all children for parent A and parent B
  //    const datesA = a.Runs.map(child => new Date(child[property]).getTime());
  //    const datesB = b.Runs.map(child => new Date(child[property]).getTime());

  //    // 2. Find the maximum (newest) timestamp for each parent
  //    const maxA = Math.max(...datesA);
  //    const maxB = Math.max(...datesB);

  //    // 3. Compare them (use "maxB - maxA" for Descending, "maxA - maxB" for Ascending)
  //    return maxB - maxA;
  //  });

  //  return sortedByNewestChild;
  //}
}
